export enum DashboardType {
    dashboard = 'dashboard',
    playmetrics = 'playmetrics'
}
